import React, { useEffect, useState } from 'react';
import classes from './SplashScreen.module.css';

/**
 * Full-screen MTN-yellow splash shown on app start.
 * - duration: total time on screen in ms (default 10s)
 * - onFinish: called once the fade-out completes
 */
const FADE_OUT_MS = 500;

const SplashScreen = ({ duration = 10000, onFinish }) => {
    const [leaving, setLeaving] = useState(false);

    useEffect(() => {
        // Lock page scroll while the splash is visible
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const fadeTimer = setTimeout(() => setLeaving(true), duration - FADE_OUT_MS);
        const doneTimer = setTimeout(() => onFinish && onFinish(), duration);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(doneTimer);
            document.body.style.overflow = previousOverflow;
        };
    }, [duration, onFinish]);

    return (
        <div
            className={`${classes.splash} ${leaving ? classes.leaving : ''}`}
            role="status"
            aria-live="polite"
            aria-label="Loading Massano"
        >
            <img
                src="/assets/images/starter.png"
                alt="MTN Massano"
                className={classes.logo}
                draggable={false}
            />

            <div className={classes.progress_track}>
                <div
                    className={classes.progress_bar}
                    style={{ animationDuration: `${duration - FADE_OUT_MS}ms` }}
                />
            </div>
        </div>
    );
};

export default SplashScreen;